import { createSlice, current } from '@reduxjs/toolkit';
export const customQueryBodySlice = createSlice({
  name: 'body',
  initialState: {
    queryStringArray: [],
    ChipArrayAddCriteria: [],
    selectedChipArray: [],
    showCard: false,
    showTable: false,
    setLoaderComp: false,
    selectedDate: '',
    dropdownEl: null,
    columns: [],
    enebleUserAccount: true,
    showCriteriaCard: true,
    checkTableData: false,
    showCalendar: true,
    isLoading: false,
    tableColumns: [],
    searchLoader: false,
    tablePageCount: '',
    tableRowCount: '',
    tableTotalCount: '',
    active: false,
    name: '',
    newExistChipArray: [],
    newSearchExistChipArray: [],
    filterCleared: false,
    newFilterApplied: false
  },
  reducers: {
    pushEntity: (state, action) => {
      if (state.queryStringArray.length) {
        state.queryStringArray = [];
      }

      state.queryStringArray[0] = action.payload;
    },
    pushShowCard: (state, action) => {
      state.showCard = action.payload;
    },
    pushShowTable: (state, action) => {
      state.showTable = action.payload;
    },
    pushSetLoaderComp: (state, action) => {
      state.setLoaderComp = action.payload;
    },
    pushOperator: (state, action) => {
      if (state.queryStringArray[0].length > 0) {
        state.queryStringArray[1] = action.payload;
      }
    },
    pushSelectedCheckList: (state, action) => {
      if (state.queryStringArray.length >= 2) {
        state.queryStringArray[2] = action.payload;
      }
    },
    pushSelectedChipArray: (state, action) => {
      state.selectedChipArray = action.payload;
    },
    pushChipArrayAddCriteria: state => {
      let existingChip = [...state.ChipArrayAddCriteria];
      state.selectedChipArray.forEach(chip => existingChip.push(chip));
      let newChipArray = [...new Set(existingChip)];
      state.ChipArrayAddCriteria = newChipArray;
      state.queryStringArray = [];
      state.selectedChipArray = [];
    },
    pushEnableUserAccountButtons: (state, action) => {
      state.enebleUserAccount = action.payload;
    },
    deleteChip: (state, action) => {
      let currentState = current(state.ChipArrayAddCriteria);
      let updatedArray = currentState.filter(chip => !chip.includes(action.payload.entityName + ' ' + action.payload.entityOpr));
      state.ChipArrayAddCriteria = updatedArray;
    },
    pushSelectedDate: (state, action) => {
      state.queryStringArray[2] = action.payload;
      state.selectedDate = action.payload;
    },
    deleteChipArrayAddCriteria: (state, action) => {
      state.ChipArrayAddCriteria = action.payload;
    },
    pushTableCols: (state, action) => {
      state.columns = action.payload;
    },
    pushTableHeadCols: (state, action) => {
      state.tableColumns = action.payload;
    },
    pushAddCriteriaCard: (state, action) => {
      state.showCriteriaCard = action.payload;
    },
    pushCheckTableData: (state, action) => {
      state.checkTableData = action.payload;
    },
    pushShowCalendar: (state, action) => {
      state.showCalendar = action.payload;
    },
    pushSearchLoader: (state, action) => {
      state.searchLoader = action.payload;
    },
    pushTablePageCount: (state, action) => {
      state.tablePageCount = action.payload;
    },
    pushTableRowCount: (state, action) => {
      state.tableRowCount = action.payload;
    },
    pushTableTotalCount: (state, action) => {
      state.tableTotalCount = action.payload;
    },
    pushStatus: (state, action) => {
      state.active = action.payload;
    },
    pushName: (state, action) => {
      state.name = action.payload;
    },
    pushNewChipArray: (state, action) => {
      state.newExistChipArray = action.payload;
    },
    pushNewSearchChipArray: (state, action) => {
      state.newSearchExistChipArray = action.payload;
    },
    resetCustomQueryBody: state => {
      state.queryStringArray = [], state.ChipArrayAddCriteria = [], state.selectedChipArray = [], state.showCard = false, state.showTable = false, state.setLoaderComp = false, state.selectedDate = '', state.dropdownEl = null, state.columns = [], state.enebleUserAccount = true, state.showCriteriaCard = true, state.checkTableData = false, state.showCalendar = true, state.isLoading = false, state.tableColumns = [], state.searchLoader = false, state.tablePageCount = '', state.tableRowCount = '', state.tableTotalCount = '', state.active = false, state.name = '', state.newExistChipArray = [], state.newSearchExistChipArray = [];
    },
    resetBodySearch: state => {
      state.newExistChipArray = [], state.newSearchExistChipArray = [];
    },
    isFilterCleared: (state, action) => {
      state.filterCleared = action.payload;
    },
    applyingNewFilter: (state, action) => {
      state.newFilterApplied = action.payload;
    }
  }
});
export const {
  pushCheckTableData,
  pushAddCriteriaCard,
  pushEnableUserAccountButtons,
  deleteChipArrayAddCriteria,
  pushSetLoaderComp,
  pushShowTable,
  pushShowCard,
  pushEntity,
  pushOperator,
  pushSelectedCheckList,
  pushSelectedChipArray,
  pushChipArrayAddCriteria,
  deleteChip,
  pushSelectedDate,
  pushTableCols,
  pushShowCalendar,
  pushTableHeadCols,
  pushSearchLoader,
  pushTablePageCount,
  pushTableRowCount,
  pushTableTotalCount,
  pushStatus,
  pushName,
  pushNewChipArray,
  pushNewSearchChipArray,
  resetCustomQueryBody,
  resetBodySearch,
  isFilterCleared,
  applyingNewFilter
} = customQueryBodySlice.actions;
export default customQueryBodySlice.reducer;